import { render, staticRenderFns } from "./reviews.participants.page.vue?vue&type=template&id=a7117068&scoped=true&"
import script from "./reviews.participants.page.vue?vue&type=script&lang=js&"
export * from "./reviews.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7117068",
  null
  
)

export default component.exports